import axios from 'axios'
import setAuthToken from '../../utils/setAuthToken'
import jwt_decode from 'jwt-decode'

import {
    GET_ERRORS,
    SET_CURRENT_USER
} from './types'

//Registration
export const registerUser = (userData, history) => dispatch => {
    axios.post('https://stat-tracker-backend.herokuapp.com/users/register', userData)
    .then(res => history.push('/login'))
    .catch(err => 
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data
        })
    )
}

//Login
export const loginUser = userData => dispatch => {
    axios.post('https://stat-tracker-backend.herokuapp.com/users/login', userData)
    .then(res => {
        //Set token to localstorage
        const { token } = res.data
        localStorage.setItem('jwtToken', token)
        //set token to auth header
        setAuthToken(token)
        //decode token to get data
        const decoded = jwt_decode(token)
        //set current user
        dispatch(setCurrentUser(decoded))
        console.log(res.data)
    })
    .catch(err =>
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data
        })
    )
}

//set logged in user
export const setCurrentUser = decoded => {
    return{
        type: SET_CURRENT_USER,
        payload: decoded
    }
}

//log out user
export const logoutUser = () => dispatch => {
    //remove token from localstorage
    localStorage.removeItem('jwtToken')
    //remove auth header for future requests
    setAuthToken(false)
    //set current user to empty object so that isAuthenticated = false
    dispatch(setCurrentUser({}))
}